import utils from '..';

export default function getMonday(date) {
	const currentDate = new Date(date);
	const currentDayOfWeek = currentDate.getDay();
	const daysUntilMonday = (currentDayOfWeek + 6) % 7;
	currentDate.setDate(currentDate.getDate() - daysUntilMonday);

	return utils.formatDateToDB(currentDate);
}